export var TextAreaType;
(function (TextAreaType) {
    TextAreaType["text"] = "text";
    TextAreaType["password"] = "password";
    TextAreaType["number"] = "number";
    TextAreaType["textArea"] = "textArea";
})(TextAreaType || (TextAreaType = {}));
//# sourceMappingURL=index.types.js.map